(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
  typeof define === 'function' && define.amd ? define(['exports'], factory) :
  (global = global || self, factory(global.XCWebSocket = {}));
}(this, (function (exports) { 'use strict';

  const EventsNames = {
      message: 'message',
      ready: 'ready',
      error: 'error'
  };
  class XCWebSocket {
      constructor(url, config) {
          this.isReconnecting = false;
          this.reconnectCount = 0;
          this.socketEvents = {
              message: [],
              ready: [],
              error: [],
          };
          this.msgStack = [];
          this.url = '';
          this.socketConfig = {
              reconnectCount: 3,
              needReconnect: true,
              heartDelay: 5000,
          };
          this.heartDelay = 3;
          if (!url.startsWith('ws://') && !url.startsWith('wss://')) {
              throw new Error('url 必须以 ws://  或 wss:// 开头');
          }
          this.url = url;
          this.socketConfig = { ...this.socketConfig, ...config };
          this.instance = this.createInstance(url, config);
      }
      reconnect() {
          if (this.isReconnecting) {
              return;
          }
          // 超出 配置的 次数之后（默认3次，没配置就是三次） 就不重连了；反正连也连不上 -。-
          if (this.reconnectCount > this.socketConfig.reconnectCount) {
              this.reconnectCount = 0;
              return;
          }
          this.reconnectCount++;
          this.isReconnecting = true;
          setTimeout(() => {
              this.instance = this.createInstance(this.url, this.socketConfig);
              this.isReconnecting = false;
          }, 2000);
      }
      createInstance(url, config) {
          let instance = new WebSocket(url);
          instance.onopen = () => {
              // 如果配置了登录消息，那么需要发送一个登录消息
              if (config.openMsg) {
                  instance.send(this.transFormMsg(config.openMsg));
              }
              // 开始发送心跳
              this.sendHeadt();
          };
          instance.onmessage = (event) => {
              this.onmessage(event);
          };
          instance.onclose = (ev) => {
              console.log('close', this, ev);
              if (this.reconnectCount > 3) {
                  this.reconnectCount = 0;
                  return;
              }
              this.reconnect();
          };
          instance.onerror = (ev) => {
              console.log('error', this, ev);
              if (this.reconnectCount > 3) {
                  this.reconnectCount = 0;
                  return;
              }
              this.reconnect();
          };
          return instance;
      }
      destory() {
          this.instance.close();
      }
      sendHeadt() {
          if (!this.socketConfig.heartMsg) {
              return;
          }
          const timer = setInterval(() => {
              if (this.instance.readyState === WebSocket.OPEN) {
                  this.send(this.transFormMsg(this.socketConfig.heartMsg));
              }
              else if (this.instance.readyState === WebSocket.CONNECTING) {
                  setTimeout(() => {
                      this.send(this.transFormMsg(this.socketConfig.heartMsg));
                  }, 1000);
              }
              else {
                  clearInterval(timer);
              }
          }, this.socketConfig.heartDelay);
      }
      transFormMsg(obj) {
          if (!obj) {
              return '';
          }
          if (typeof obj === "string") {
              return obj;
          }
          return JSON.stringify(obj);
      }
      send(data) {
          if (this.instance.readyState === WebSocket.OPEN) {
              this.instance.send(this.transFormMsg(data));
          }
          else {
              this.msgStack.push(data);
              this.on(EventsNames.ready, () => {
                  this.msgStack.forEach((item) => {
                      this.instance.send(this.transFormMsg(item));
                  });
              });
          }
      }
      onmessage(event) {
          const data = JSON.parse(event.data);
          if (data.action === 0) {
              this.emit(EventsNames.ready);
          }
          else {
              this.emit(EventsNames.message, data);
          }
      }
      on(key, fn) {
          if (Object.keys(this.socketEvents).includes(key)) {
              this.socketEvents[key].push(fn);
          }
          else {
              throw new Error('请不要在本库监听与本库无关的事件: ' + key);
          }
      }
      emit(key, ret) {
          if (this.socketEvents[key]) {
              this.socketEvents[key].forEach(fn => {
                  fn(ret);
              });
          }
      }
      getInstance() {
          return this.instance;
      }
  }

  exports.EventsNames = EventsNames;
  exports.default = XCWebSocket;

  Object.defineProperty(exports, '__esModule', { value: true });

})));
//# sourceMappingURL=index.js.map
